export default __webpack_public_path__ + "static/media/discordLight.04f0f34d.svg";